import { useCallback, useEffect, useState } from 'react'
import styled from 'styled-components'
import { toast } from 'react-toastify'
import taskLinksAPI from 'features/taskLinks/taskLinksAPI'
import SuggestionRow from 'features/taskLinks/SuggestionRow'
import { SUGGESTION_HELP, errorMessage } from 'features/taskLinks/linkCopy'
import { INK, MUTED } from 'features/actions/workspace/ui'

const RemedialSuggestions = ({ action, onChanged }) => {
  const [items, setItems] = useState([])
  const [busy, setBusy] = useState(null)
  const bpId = action?.buildingPassport?.id || action?.buildingPassportId
  const fileId = action?.sourceFileId
  const actionId = action?.id

  const load = useCallback(() => {
    if (!bpId || !fileId || !actionId) {
      setItems([])
      return
    }
    taskLinksAPI.fileLinks(bpId, fileId)
      .then(res => {
        const mine = (res?.data?.data?.remedials || []).find(r => r.id === actionId)
        setItems(mine?.suggestions || [])
      })
      .catch(() => setItems([]))
  }, [bpId, fileId, actionId])

  useEffect(() => { load() }, [load])

  if (!items.length) return null

  const run = async (key, fn, message) => {
    setBusy(key)
    try {
      await fn()
      toast.success(message)
      load()
      onChanged?.()
    } catch (err) {
      toast.error(errorMessage(err))
    } finally {
      setBusy(null)
    }
  }

  return (
    <Box aria-labelledby={`suggested-${actionId}`}>
      <Heading id={`suggested-${actionId}`}>Possibly already handled by</Heading>
      <Help>{SUGGESTION_HELP}</Help>
      {items.map(s => (
        <SuggestionRow
          key={s.matchId}
          title={s.task?.title}
          to={`/tasks/${s.task?.id}`}
          statusValue={s.task?.status}
          deadline={s.task?.deadline}
          isRoutine={s.task?.isRoutine}
          reasons={s.reasons}
          canManage
          busy={busy === s.matchId}
          onLink={relation => run(s.matchId, () => taskLinksAPI.link(actionId, s.task.id, relation), 'Task linked to this remedial.')}
          onDismiss={() => run(s.matchId, () => taskLinksAPI.dismiss(s.matchId), 'Got it. We will not suggest that task again.')}
        />
      ))}
    </Box>
  )
}

export default RemedialSuggestions

const Box = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin-top: 4px;
`

const Heading = styled.h4`
  margin: 0;
  font-size: 15px;
  font-weight: 700;
  color: ${INK};
`

const Help = styled.p`
  margin: 0;
  font-size: 14px;
  line-height: 1.5;
  color: ${MUTED};
`
